<template>
  <div class="fddform-checkbox-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'FddCheckboxGroup',
    props: {
      value: {
        type: Array
      }
    }
  }
</script>
